// Helper to open WhatsApp using the browser's normal link handling.
export function openWhatsAppWindow(url: string): void {
  try {
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (err) {
    console.error('openWhatsAppWindow failed', err)
  }
}
